const PALETTE = ["#2563eb", "#10b981", "#9333ea", "#ea580c", "#db2777", "#0891b2", "#ca8a04", "#dc2626"];

export function getEntityColor(index: number): string {
  return PALETTE[index % PALETTE.length];
}
